import { IAppointment, IChatConversation } from 'src/types';
import { DIAG_PRICE } from 'src/utils/data';
import {
  IQuoteState,
  IQuoteZipcodePayload,
  EstimateItemStatusPayload,
  IQuoteDiagnosisPricePayload,
  IReduxAction,
  QUOTE_SET_APPOINTMENT,
  QUOTE_SET_ZIP,
  ESTIMATE_ITEM_STATUS,
  QUOTE_SET_CHAT,
  QUOTE_SET_DIAGNOSIS_PRICE,
} from '../types';

const initialState: IQuoteState = {
  zip: '',
  customer: 0,
  appointment: null,
  chat: null,
  diagnosisPrice: DIAG_PRICE, // Default to $120
};

export default (
  state = initialState,
  action: IReduxAction
): typeof initialState => {
  switch (action.type) {
    case QUOTE_SET_ZIP:
      return {
        ...state,
        zip: (action.payload as IQuoteZipcodePayload).zip || state.zip,
        customer:
          (action.payload as IQuoteZipcodePayload).customer || state.customer,
      };
    case QUOTE_SET_APPOINTMENT:
      return {
        ...state,
        appointment: action.payload as IAppointment,
      };
    case QUOTE_SET_CHAT:
      return {
        ...state,
        chat: action.payload as IChatConversation,
      };
    case ESTIMATE_ITEM_STATUS: {
      const appt = state.appointment;
      if (appt && state.appointment) {
        Object.assign(state.appointment, appt);
      }
      const { s, status } = action.payload as EstimateItemStatusPayload;

      if (appt?.attributes.estimate?.services) {
        appt.attributes.estimate.services[s].status = status;
      }

      return {
        ...state,
        appointment: appt,
      };
    }
    case QUOTE_SET_DIAGNOSIS_PRICE:
      return {
        ...state,
        diagnosisPrice: (action.payload as IQuoteDiagnosisPricePayload).price,
      };
    default:
      return state;
  }
};
